// extracted by mini-css-extract-plugin
export var chatHtmlText = "_iv-2";
export var chatLink = "_iv-0";
export var chatText = "_iv-1";